module.exports = __webpack_public_path__ + "static/media/referral-image.3f0b792e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referral-image.png
// module id = 2331
// module chunks = 17